import { ensureWxForH5 } from "./wx-h5";

ensureWxForH5();
